import { render, staticRenderFns } from "./MonitoringDataTable.vue?vue&type=template&id=06cd81da"
import script from "./MonitoringDataTable.vue?vue&type=script&lang=js"
export * from "./MonitoringDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports